import { StyledText } from './style'

const Text = ({ children, className, ...props }) => {
  return (
    <StyledText className={className} {...props}>
      {children}
    </StyledText>
  )
}

export default Text
